module.exports = __webpack_public_path__ + "static/media/vickramCollegeLogo.ccf73750.jpeg";